import { render, staticRenderFns } from "./packageuseditem.vue?vue&type=template&id=4fb65ecb&scoped=true&"
import script from "./packageuseditem.vue?vue&type=script&lang=js&"
export * from "./packageuseditem.vue?vue&type=script&lang=js&"
import style0 from "./packageuseditem.vue?vue&type=style&index=0&id=4fb65ecb&scoped=true&lang=less&"
import style1 from "./packageuseditem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb65ecb",
  null
  
)

export default component.exports